import React, { useState, useEffect } from 'react'
import Select from 'react-select';
import { useGetEcoQuiz } from '../../../queries/challenge'
import { useForm } from 'react-hook-form';
import { ActionButton } from '../../../components/Forms/ActionButton';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useGetAppDisplayConfig, useUpdateEcoQuizzes } from '../../../queries/homepageOrganizer';

const EcoQuiz = () => {
    const { data: ecoQuizList, isPending: isQuizListPending } = useGetEcoQuiz();
    const { mutateAsync: setEcoQuizzes, isPending: isUpdating } = useUpdateEcoQuizzes();
    
    const [selectedQuizzes, setSelectedQuizzes] = useState([]);
    const [showEcoQuizzes, setShowEcoQuizzes] = useState(false);
    
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        watch
    } = useForm();

    // Initialize selected quizzes based on quizOfTheDay flag
    useEffect(() => {
        if (ecoQuizList) {
            const currentQuizzes = ecoQuizList.filter(quiz => quiz.quizOfTheDay);
            setShowEcoQuizzes(currentQuizzes.length > 0);
            
            // Map current quizzes to format for react-select
            const selectedOptions = currentQuizzes
                .map(quiz => ({ value: quiz._id, label: quiz.title }));
                
            setSelectedQuizzes(selectedOptions);
        }
    }, [ecoQuizList]);

    const onSubmit = async (data) => {
        try {
            // Extract just the values (IDs) from the selectedQuizzes array
            const quizIds = selectedQuizzes.map(quiz => quiz.value);
            
            await setEcoQuizzes({
                quizIds: quizIds,
                active: showEcoQuizzes,
            }, {
                onSuccess: () => {
                    toast.success("Eco Quizzes updated successfully");
                },
                onError: (error) => {
                    toast.error("Failed to update Eco Quizzes");
                    console.error(error);
                }
            });
        } catch (error) {
            toast.error("Something went wrong");
            console.error(error);
        }
    };
    
    if (isQuizListPending) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="loader">Loading...</div>
            </div>
        );
    }

    return (
        <div className=" bg-white shadow-md rounded-lg p-5 mb-10">
            <h2 className="text-xl text-primary font-bold">Eco Quiz Selection</h2>
            {/* <div className='mt-2 flex items-center gap-2'>
                <p className="text-base text-primary font-bold">Show eco quizzes in app</p>
                <div className={`flex justify-end items-center border ${showEcoQuizzes ? `border-primary` : `border-inactive`} rounded-md h-full min-h-8 min-w-20`}>
                    <label className="inline-flex items-center me-5 cursor-pointer h-full">
                        <span className={`ms-3 text-base ${showEcoQuizzes ? `text-primary` : 'text-inactive'} font-bold dark:text-gray-300 mr-2`}>{showEcoQuizzes ? 'Yes' : 'No'}</span>
                        <input 
                            type="checkbox" 
                            name={'showEcoQuizzes'} 
                            value={showEcoQuizzes} 
                            className="sr-only peer" 
                            onChange={() => setShowEcoQuizzes(!showEcoQuizzes)} 
                            checked={showEcoQuizzes} 
                        />
                        <div className="relative w-8 h-4 bg-white border-black ring-1 ring-inactive rounded-full peer dark:bg-white peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.1 after:start-[0px] after:bg-inactive after:border-inactive peer-checked:after:bg-white after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-navBtn peer-checked:ring-primary peer-checked:bg-primary"></div>
                    </label>
                </div>
            </div> */}
            
            <div className='mt-2 flex flex-col items-start gap-2'>
                <p className="text-base text-primary font-bold">Current eco quizzes in app:</p>
                {ecoQuizList?.filter(quiz => quiz.quizOfTheDay)?.length > 0 ? (
                    <ul className="ml-4 list-disc">
                        {ecoQuizList.filter(quiz => quiz.quizOfTheDay).map(quiz => (
                            <li key={quiz._id} className="text-base font-semibold">{quiz.title}</li>
                        ))}
                    </ul>
                ) : (
                    <p className="text-base font-semibold">None</p>
                )}
            </div>
            
            <form onSubmit={handleSubmit(onSubmit)}>
                {/* Quiz selection */}
                <div className="flex flex-col flex-1 grow shrink-0 basis-0 min-h-[65px] w-full mt-4">
                    <label className="gap-1 self-stretch text-base w-full text-gray-900 font-semibold capitalize">
                        Select eco quizzes
                    </label>
                    <Select
                        options={ecoQuizList?.map((quiz) => ({
                            value: quiz._id,
                            label: quiz.title,
                        }))}
                        isMulti={true}
                        isLoading={isQuizListPending}
                        placeholder="Select eco quizzes"
                        classNamePrefix="select"
                        className='mt-1 text-base'
                        value={selectedQuizzes}
                        isClearable
                        isSearchable
                        name='ecoQuizzes'
                        onChange={(selectedOptions) => {
                            setSelectedQuizzes(selectedOptions || []);
                            setShowEcoQuizzes(selectedOptions?.length > 0);
                        }}
                        noOptionsMessage={() => "No quizzes available"}
                        styles={{
                            control: (base, state) => ({
                                ...base,
                                backgroundColor: 'transparent',
                                border: `1px solid ${errors.ecoQuizzes ? 'red' : 'rgba(224, 230, 237, 1)'}`,
                                borderRadius: '0.375rem',
                                boxShadow: state.isFocused ? (errors.ecoQuizzes ? '0 0 0 1px red' : '0 0 0 1px #16ad3c') : 'none',
                                padding: '0.15rem',
                                ":hover": {
                                    borderColor: errors.ecoQuizzes ? 'red' : '#16ad3c',
                                },
                            }),
                            menu: (base) => ({
                                ...base,
                                zIndex: 9999,
                            }),
                            option: (base, { isSelected }) => ({
                                ...base,
                                backgroundColor: isSelected ? '#16ad3c' : 'white',
                                color: isSelected ? 'white' : 'black',
                                ":active": {
                                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(0, 0, 0, 0.1)',
                                },
                                ":hover": {
                                    backgroundColor: isSelected ? '#16ad3c' : 'rgba(52, 199, 89, 0.3)',
                                },
                            }),
                            multiValue: (base) => ({
                                ...base,
                                backgroundColor: 'rgba(52, 199, 89, 0.1)',
                                borderRadius: '4px',
                            }),
                            multiValueLabel: (base) => ({
                                ...base,
                                color: '#16ad3c',
                            }),
                            multiValueRemove: (base) => ({
                                ...base,
                                color: '#16ad3c',
                                ':hover': {
                                    backgroundColor: 'rgba(52, 199, 89, 0.2)',
                                    color: '#16ad3c',
                                },
                            }),
                        }}
                    />
                </div>
                
                <div className='flex justify-end mt-5'>
                    <ActionButton
                        text={'Submit'}
                        variant={'submit'}
                        disabled={isUpdating}
                    />
                </div>
            </form>
            <ToastContainer position="top-right" autoClose={3000} />
        </div>
    )
}

export default EcoQuiz